export default __webpack_public_path__ + "static/media/Luigi_Florio_Foresta_incantata_30_x_40_cm.be604a3b.jpg";